import lazyLoad from './../utils/lazy'

const cFeaturedCasesInit = () => {
  const init = (box) => {
    if (!box) return 1;

    let mouseOver = false;
    let progress = 0;
    let timer;
    let time = 5000;
    let fps = 1000/25;
    let step = (fps/time) * 100;


    window.onresize = () => {
      clearTimeout(timer);
      autoplay();
      let active = box.querySelector('.c-fc-header .col.active');
      if(active){
        slideAnimation(active);
      }
    };

    let header = box.querySelector('.c-fc-header');

    header.addEventListener("mouseenter", () => {
      mouseOver = true;
    });
    header.addEventListener("mouseleave", () => {
      mouseOver = false;
    });

    let box_ref = box.querySelector('.c-fc-slider');

    let slides = box.querySelectorAll('.c-fc-header .col');
    let slides_count = slides.length;
    if(slides_count){
      for(let i = 0; i < slides_count; i++){
        let slide = slides[i];
        if(i === 0){
          slide.classList.add('active');
        }
        slide.onclick = () => {
          if(!slide.classList.contains('active')){
            changeSlide(slide);
          }
        };
      }
    }

    function changeSlide(el){
      if (!el) return 1;
      let active = box.querySelector('.c-fc-header .col.active');
      if(active){
        active.classList.remove('active');
        let index = active.dataset.index;
        let slide = box.querySelector('.c-fc-slide[data-index="'+ index +'"]');
        slide.classList.remove('active');
      }
      el.classList.add('active');
      let index = el.dataset.index;
      let slide = box.querySelector('.c-fc-slide[data-index="'+ index +'"]');
      slide.classList.add('active');
      progress = 0;
      slideAnimation(el);
      lazyLoad();
    }

    function slideAnimation(el) {
      let index = el.dataset.index;
      let box_width = box_ref.clientWidth;
      box_ref.scrollTo({
        top: 0,
        left: box_width * index,
        behavior: 'smooth'
      });
    }

    function next() {
      let active = box.querySelector('.c-fc-header .col.active');
      if(active){
        let index = active.dataset.index;
        let next = box.querySelector('.c-fc-header .col[data-index="' + (+index+1) + '"]');
        if(!next){
          next = box.querySelector('.c-fc-header .col[data-index="0"]');
        }
        changeSlide(next);
        clearTimeout(timer);
        autoplay();
      }
    }

    function prev() {
      let active = box.querySelector('.c-fc-header .col.active');
      if(active){
        let index = active.dataset.index;
        let prev = box.querySelector('.c-fc-header .col[data-index="' + (+index-1) + '"]');
        if(!prev){
          let count = box.querySelectorAll('.c-fc-header .col').length;
          if(count){
            prev = box.querySelector('.c-fc-header .col[data-index="' + (+count-1) + '"]');
          }
        }
        changeSlide(prev);
        clearTimeout(timer);
        autoplay();
      }
    }

    function autoplay () {
      if(!mouseOver){
        progress += step;
      }
      let loader = box.querySelector('.c-fc-header .col.active .loader span');
      if(loader){
        loader.style.width = progress + '%';
      }
      if(progress < 100){
        timer = setTimeout(autoplay, fps);
      } else {
        next();
      }
    }

    autoplay();

  };

  let box = document.querySelectorAll('.slider-cases');
  let count = box.length;
  if(count > 0){
    for(let i = 0; i < count; i++){
      init(box[i]);
    }
  }
};

export default cFeaturedCasesInit
